/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "a9ba4f7c4296614c88450969d5aaa9cb34311d9d";
